/** @jsxImportSource @emotion/react */
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import React, { useEffect } from 'react';

import { loginRequest } from '../../authConfig';
import b2cEnvVariables from '../../b2cEnvVariables';
import HiddenContent from '../HiddenContent';

const SignUp = () => {
  const { instance } = useMsal();
  const appConfig = b2cEnvVariables(process.env.REACT_APP_ENVIRONMENT);
  const isAuthenticated = useIsAuthenticated();

  // for signup request
  const SIGNUP_REQUEST = {
    ...loginRequest,
    authority: `${appConfig.AuthUrl}/${appConfig.Tenant}/${appConfig.SignUpPolicyId}`,
  };

  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.setItem('rootUrl', localStorage.getItem('pathInfomation'));
      instance.loginRedirect(SIGNUP_REQUEST)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <HiddenContent>Redirecting to signUp page</HiddenContent>;
};

export default SignUp;